@let obs =
  {
    carousel: carousel$ | async,
    products: products$ | async,
    isLoading: isLoading$ | async,
  };

@if (obs.isLoading) {
  @if (skeletonSlidesPerView()) {
    <div class="product-carousel-skeleton sd-group-skeleton-gradient-wave">
      <div class="product-carousel-skeleton-top">
        <div class="product-carousel-skeleton-title sd-skeleton"></div>
        <div class="product-carousel-skeleton-paging sd-skeleton"></div>
      </div>
      <div class="product-carousel-skeleton-content">
        @for (i of [].constructor(skeletonSlidesPerView()); track $index) {
          <div class="product-carousel-skeleton-item sd-skeleton"></div>
        }
      </div>
    </div>
  }
} @else if (obs.carousel && obs.products?.length) {
  <div
    class="product-carousel"
    [sdInViewport]="0.25"
    [intersectedOnce]="true"
    (intersected)="onCarouselViewportIntersect()"
  >
    <sd-swiper
      [items]="obs.products"
      [config]="swiperConfig"
      [title]="obs.carousel.title"
      [equalHeightSlides]="true"
      (activeIndexChange)="onSwiperActiveIndexChange($event)"
      (slidesPerViewChange)="onSwiperSlidesPerViewChange($event)"
      (swiperInit)="onSwiperInit($event)"
    >
      <ng-template let-item="item" let-index="index">
        <sd-product-item [product]="item" [productIndex]="index"></sd-product-item>
      </ng-template>
    </sd-swiper>
  </div>
}
